// extracted by mini-css-extract-plugin
module.exports = {"parent":"style_parent__0IFw7","child":"style_child__b4HW3","input":"style_input__EoPcb","label":"style_label__y6y1J"};